import kidimage from '../Images/slider_slide1_img1.png';

export default function AboutSection(){
    return (
      <section id="aboutSection">
      <div className="container">
        <div className="text-container">
          <h1 className="front-text">A Bright Start for Your Little Ones</h1>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSfPFmWS__ZwGAUTdfddj1q9eM5rLBDxLU1JpBxuBG2zNu7HJg/formResponse" className="enquiry-button" target="_blank">Enquiry Form</a>
        </div>
        <img className="about-image" src={kidimage} alt="Image" />
      </div>
    </section>    
    )
}